import { Heart, Tray, Star, Buildings } from '@phosphor-icons/react';

import { ROUTES } from 'theSource/app/routes';


export const NAV_ITEMS = [
  {
    label: 'myBenefitsTileLabel',
    path: ROUTES.additional.benefits.myBenefits.path,
    phosphorIcon: Heart,
    lookupCode: 'my_benefits',
  },
  {
    label: 'myInboxTileLabel',
    path: ROUTES.main.inbox.path,
    phosphorIcon: Tray,
    lookupCode: 'my_inbox',
  },
  {
    label: 'myPaycheckTileLabel',
    path: ROUTES.main.home.path,
    phosphorIcon: Star,
    lookupCode: 'see_my_paycheck',
  },
  {
    label: 'myCompanyTileLabel',
    path: ROUTES.additional.company.myCompany.path,
    phosphorIcon: Buildings,
    lookupCode: 'my_company',
  },
];

export const GET_TOP_NAV_QUERY_KEY = ['topNav'] as const;
